import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { ProcessQueueDefinition } from '../../types/process-group-definition.type';

@Injectable({ providedIn: 'root' })
export class MonitoringConfigurationApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/monitoring-configuration`;
  }

  async getRPAProcesses(): Promise<ProcessQueueDefinition[]> {
    return await this.get<ProcessQueueDefinition[]>('processes');
  }

  async updateRPAProcess(process: ProcessQueueDefinition): Promise<void> {
    return await this.put('processes', process);
  }

  async getUnassignedProcesses(): Promise<ProcessQueueDefinition[]> {
    return await this.get<ProcessQueueDefinition[]>('unassigned-processes');
  }

  async getQueues(): Promise<ProcessQueueDefinition[]> {
    return await this.get<ProcessQueueDefinition[]>('queues');
  }

  async getUnassignedQueues(): Promise<ProcessQueueDefinition[]> {
    return await this.get<ProcessQueueDefinition[]>('unassigned-queues');
  }

  async updateQueue(queue: ProcessQueueDefinition): Promise<void> {
    return await this.put('queues', queue);
  }

  async getResources(): Promise<ProcessQueueDefinition[]> {
    return await this.get<ProcessQueueDefinition[]>('resources');
  }

  async setResourceIsHidden(resourceId: string, isHidden: boolean): Promise<void> {
    return await this.patch(`resources/${resourceId}/is-hidden`, isHidden);
  }
}
